import React, { useState, useCallback, useEffect } from 'react'
import Modal from '@mui/material/Modal'
import { Box, DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { Input } from 'Components/Input'
import Button from '@mui/material/Button'
import ProjectPng from 'Components/images/Project icone Big.png'
import CustomButton from 'Components/CustomButton/CustomButton'
import TaskPng from 'Components/images/Task Icon big.png'
import { makePostRequest, makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import CreateTache from './CreateTache'
import ComboBox from 'Components/ComboBox'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 500,
  borderRadius: 2,

  bgcolor: 'background.paper',
  boxShadow: 24,
}

export default function CreateListe({
  setCreateListe,
  setListeList,
  updateTodo = false,
  setProjectRow = '',
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modelOpen, setModelOpen] = useState(true)
  const [createTache, setCreateTache] = useState(false)
  const [tachePayload, setTachePayload] = useState(false)
  const [domain, setDomain] = useState([])

  const CreateTacheModal = () => {
    setCreateTache(true)
  }
  const handleModelClose = () => {
    setModelOpen(false)
    setCreateListe(false)
    reset()
  }

  const { handleSubmit, control, reset, setValue } = useForm({
    defaultValues: {},
  })
  useEffect(() => {
    fetchDomain()
  }, [])

  const fetchDomain = async () => {
    const url = urls.getDomain + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.domain}`, id: v.id })
      })
      setDomain([...filterTypes])
    }
  }

  const onSubmit = async (data) => {
    let payload = {}
    payload = {
      ...data,
      LifeDomain: data.LifeDomain.id,
    }

    const response = await makePostRequest(urls.listeOperations, payload, {}, true)
    if (response.status === 201) {
      let listeData = response.data
      listeData = {
        ...listeData,
        tasks: [],
      }
      let pId = listeData.id
      if (tachePayload) {
        let payload = {}
        payload = {
          ...tachePayload,
          ListeId: pId,
        }
        const response = await makePostRequest(urls.taskOperations, payload, {}, true)
        if (response.status === 201) {
          listeData.tasks = [response.data]
        }
      }
      setListeList((liste) => [...liste, listeData])
      handleModelClose()
      if (updateTodo) updateTodo()
    }
  }

  return (
    <>
      <Modal
        open={modelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ '.nouvelli': { width: isMobile ? '90%' : '500px' } }}
      >
        <Box sx={mstyle} className="nouvelli">
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleModelClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    {t('mesToDo.newList')}
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'text',
                        }}
                        rules={{ required: true }}
                        name="Name"
                        label={t('mesToDo.fieldListName')}
                      />

                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('LifeDomain', j)
                        }}
                        label={t('mesToDo.fieldDomain')}
                        data={domain}
                        name="LifeDomain"
                        required={true}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '0',
                          '& Button': { minWidth: '0', color: '#434343', padding: '0' },
                        }}
                      >
                        <CustomButton
                          onClick={() => {
                            CreateTacheModal()
                          }}
                        >
                          <img alt="" src={TaskPng} />
                        </CustomButton>
                        {/* <CustomButton>
                                                    <img style={{ height: '42px' }} alt='' src={ProjectPng} />
                                                </CustomButton> */}
                      </Box>
                      <Button sx={{ marginLeft: 'auto !important' }} type="submit">
                        {t('mesToDo.validate')}
                      </Button>
                    </DialogActions>
                  </form>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      {createTache && (
        <CreateTache
          setCreateTache={setCreateTache}
          setTachePayload={setTachePayload}
          setpayloadcheck={true}
        />
      )}
    </>
  )
}
